<mat-form-field class="errors-only" *ngIf="errorStateMatcher.errors.length">
    <input matInput="" [(ngModel)]="value"
           [errorStateMatcher]="errorStateMatcher">
    <mat-error *ngFor="let error of errorStateMatcher.errors"
               [class.bigger]="bigger">
        {{ error.description ? error.description : error.code }}
    </mat-error>
</mat-form-field>
